<template>
  <modal
    ref="modal"
    title="Add new investor"
    :show-loading="form.submitInProgress"
  >
    <div slot="modal-body">
      <div class="row">
        <form class="form-horizontal">
          <div class="form-group">
            <label for="nameField" class="col-sm-2 control-label">Name</label>
            <div class="col-sm-10">
              <input
                id="nameField"
                v-model="form.data.name"
                class="form-control"
                :class="{ 'has-errors': form.hasErrors('name') }"
                placeholder="Name"
                @keypress.enter.prevent="form.submit()"
              />
              <p
                v-for="error in form.errors.name"
                :key="error"
                class="text-danger"
              >
                {{ error }}
              </p>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div slot="modal-footer">
      <button type="button" class="btn btn-default" @click="close()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary btn-transparent"
        @click="form.submit()"
      >
        Add
      </button>
    </div>
  </modal>
</template>

<script>
import http from '@/services/http'
import { Form } from '@/utils/forms'

export default {
  props: {},
  data() {
    const self = this
    return {
      form: new Form({
        fields: [{ name: 'name' }],
        url: '/investors/create',
        delay: 200,
        onSuccess({ response }) {
          self.$emit('investor-created', { investor: response.data })
          self.form.clean()
        },
      }),
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
  },
}
</script>
